import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "New Year's Eve Edition",
  date: new Date(2023, 11, 31),
  img: "/img/2023.jpeg",
  tracks: [
    {
      title: "Special Blend",
      src: "/songs/2023-12-31/special_blend.mp3",
    },
    {
      title: "Old Lang's Sign",
      src: "/songs/2023-12-31/old_langs_sign.mp3",
    },
    {
      title: "Ring In The New Year",
      src: "/songs/2023-12-31/ring_in_the_new_year.mp3",
    },
    {
      title: "Mocktail Party",
      src: "/songs/2023-12-31/mocktail_party.mp3",
    },
    {
      title: "Feed The Dog, Feed The Cat",
      src: "/songs/2023-12-31/feed_the_dog_feed_the_cat.mp3",
    },
    { title: "Afterglow", src: "/songs/2023-12-31/afterglow.mp3" },
    { title: "Mermaids", src: "/songs/2023-12-31/mermaids.mp3" },
    {
      title: "Out With The Old",
      src: "/songs/2023-12-31/out_with_the_old.mp3",
    },
    {
      title: "Hold Me Tight",
      src: "/songs/2023-12-31/hold_me_tight.mp3",
    },
    {
      title: "Thank You, David",
      src: "/songs/2023-12-31/thank_you_david.mp3",
    },
    {
      title: "I Really Like Your Shoes",
      src: "/songs/2023-12-31/i_really_like_your_shoes.mp3",
    },
    { title: "Talkin' Smack", src: "/songs/2023-12-31/talkin_smack.mp3" },
    {
      title: "Our Own Little Time Capsule",
      src: "/songs/2023-12-31/our_own_little_time_capsule.mp3",
    },
    {
      title: "Fireworks Show",
      src: "/songs/2023-12-31/fireworks_show.mp3",
    },
    { title: "Mellowdious", src: "/songs/2023-12-31/mellowdious.mp3" },
    {
      title: "How Emily Got Her Groove Back",
      src: "/songs/2023-12-31/how_emily_got_her_groove_back.mp3",
    },
    { title: "Drunk Uncle", src: "/songs/2023-12-31/drunk_uncle.mp3" },
  ],
};
export default album;
